import ApiService from '@/common/api.service'
import Vue from 'vue'

const uuid = require('uuid/v4');

const SUBVENTION_REMAINDER_CASH = 1
const SUBVENTION_REMAINDER_RETENTION = 2

const SUBVENTION_TYPE_PERCENT = 1
const SUBVENTION_TYPE_ABSOLUTE = 2

/*
* Current order empty template
*/
const ORDER = {
    id: undefined,
    synced_id: undefined,
    user: null,
    customer: null,
    parent_id: null,
    status: null,
    items: [],
    //total: 0, // replaced by getter
    taxes: null,
    synced: 0,
    payments: {
        cash: 0,
        credit: 0,
        voucher: 0,
        card: 0,
        subvention: 0
    }
}

const state = {
    order: null,
    orders: [],
    unsynced: [],
}

const getters = {

    /*
    *
    */
    order: (state) => state.order,

    /*
    *
    */
    orders: (state) => state.orders,

    /*
    *
    */
    taxes: (state) => state.order.taxes,

    /*
    *
    */
    customer: (state) => state.order.customer,

    /*
    *
    */
    unsynced: (state) => state.unsynced,

    /*
    * returns total amount
    */
    total: (state) => {
        let total = 0
        state.order.items.forEach(item => {
            total += item.qty * item.product.base_price // todo +modifiers
        })

        return total
    },

    /*
    * return subvention
    *
    */
    subvention: (state, getters, rootState, rootGetters) => {
        let total = 0 // get total of items that can have subvention
        state.order.items.forEach(item => {
            total += item.product.no_subvention === true ? 0 : item.qty * item.product.base_price
        })

        let company = rootGetters['user/info'].company.data
        let subvention = 0
        if(0) {
            return {
                total: total,
                value: 0
            }
        }

        if(company.subvention_reminder == SUBVENTION_REMAINDER_CASH) {
            if(company.subvention_type == SUBVENTION_TYPE_PERCENT) {
                let value = total * Number(company.subvention_value) / 100
                if(Number(company.subvention_max) > 0) {
                    subvention = Math.min(Number(company.subvention_max), value)
                } else {
                    subvention = value
                }
            } else if(company.subvention_type == SUBVENTION_TYPE_ABSOLUTE) {
                subvention = Number(company.subvention_value)
            }
        }

        if(company.subvention_reminder == SUBVENTION_REMAINDER_RETENTION) {
            if(Number(company.subvention_retention_max) > 0) {
                subvention = Math.min(total, Number(company.subvention_retention_max))
            } else {
                subvention = total
            }
        }

        return {
            total: total,
            value: subvention
        }
    },

    /*
    * return grand total (including subvention)
    *
    */
    gt: (state, getters) => {
        if(getters.total <= 0) {
            return 0
        } else {
            return getters.total// - getters.subvention.value
        }
    },

    /*
    * return total registered payments
    *  - cash
    *  - credit
    *  - voucher
    *  - card
    *  - subvention
    */
    payed: (state) => {
        return state.order.payments.cash +
        state.order.payments.credit +
        state.order.payments.voucher +
        state.order.payments.card +
        state.order.payments.subvention
    },

    /*
    * return order balance
    */
    balance: (state, getters) => {
        return Math.max(0, getters.total - getters.payed) // - getters.subvention.value)
    }
}

const actions = {
    /*
    * Creates a new blank current order
    * by using ORDER template. Uses JSON.parse and stringify
    * to deep clone without reactivity
    */
    createNewOrder: (context) => {
        let order = JSON.parse(JSON.stringify(ORDER))
        order.timestamp = +new Date
        order.user = context.rootState.user
        context.commit('order/order', order, { root: true })
    },

    /*
    * Add an item to current order
    */
    addItemToOrder: (context, item) => {
        item.timestamp = +new Date // Date.now()
        context.commit('order/order_item_add', item, { root: true })
    },

    /*
    * Add builder item to current order as item
    */
    addBuilderItemToOrder: (context) => {
        let builder = context.rootState.products.builder
        let item = builder.product
        item.categories = builder.categories
        item.timestamp = +new Date
        context.commit('order/order_item_add', item, { root: true })
    },

    /*
    * Cancel current order
    */
    cancelOrder: ({commit, dispatch, state}) => {
        dispatch('createNewOrder')
    },

    /*
    * Close and submit current order
    * Add order to orders collection
    */
    closeOrder: ({commit, dispatch, state, getters}) => {
        return new Promise((resolve, reject) => {
            // update total
            commit('total', getters.total)
            // save order to local db
            vm.$db.addOrder(state.order).then(id => {
                // create a deep clone without reactivity
                let order = Object.assign({}, {local_id: id}, JSON.parse(JSON.stringify(state.order)))
                // then send it to the api
                ApiService.post('pos/order', order).then(result => {
                    vm.$db.updateSyncedOrder(id, result.data.data)
                }).catch(err => {
                    vm.$toasted.show(err)
                }).finally(() => {
                    resolve()
                })
                dispatch('createNewOrder')
            }).catch(err => {
                vm.$toasted.show(err)
                reject(err)
            }).finally(() => {
                dispatch('getUnsynced')
            })
        })
    },

    /*
    * Restore current order if exists
    *
    */
    restoreOrder: (context) => {
        return new Promise((resolve, reject) => {
            let user_id = context.rootState.user.info.id
            vm.$db.getOrder(user_id).then(order => {
                if(order) {
                    context.commit('order/order', order, { root: true })
                    resolve(order)
                } else {
                    reject()
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    /*
    * load preorder by nfc
    *
    */
    loadPreorder: (context, nfc) => {
        return new Promise((resolve, reject) => {
            ApiService.get(`pos/preorder/${nfc}?include=customer,customer.company,shift,location`).then((result) => {
                let order = JSON.parse(JSON.stringify(ORDER))
                let preorder = result.data.data
                let today = new Date().toISOString().slice(0, 10)
                order.day = preorder.day ? preorder.day : today
                order.parent_id = preorder.id
                order.items = preorder.items.data
                order.total = preorder.total * 1
                order.taxes = preorder.taxes * 1
                order.status = preorder.status
                order.customer = preorder.customer.data
                order.user = preorder.user.data
                order.shift = preorder.shift ? preorder.shift.data : null
                order.location = preorder.location ? preorder.location.data : null
                context.commit('order/order', order, { root: true })
                resolve(order)
            }).catch(err => {
                vm.$db.getPreorder(nfc).then( result => {
                    let order = JSON.parse(JSON.stringify(ORDER))
                    let preorder = result
                    let today = new Date().toISOString().slice(0, 10)
                    order.day = preorder.day ? preorder.day : today
                    order.parent_id = preorder.id
                    order.items = preorder.items.data
                    order.total = preorder.total * 1
                    order.taxes = preorder.taxes * 1
                    order.status = preorder.status
                    order.customer = preorder.customer.data
                    order.user = preorder.user.data
                    order.shift = preorder.shift ? preorder.shift.data : null
                    order.location = preorder.location ? preorder.location.data : null
                    context.commit('order/order', order, { root: true })
                    resolve(order)
                }).catch( err => {
                    reject(err)
                })
            })
        })
    },

    /*
    *
    */
    setPayment: (context, payment) => {
        context.commit('order/payment', {
            type: payment.type,
            amount: payment.amount
        }, { root: true })
    },

    /*
    *
    */
    getUnsynced: (context) => {
        vm.$db.getUnsyncedOrders().then(unsynced => {
            context.commit('order/unsynced', unsynced, { root: true })
        })
    },

    loadPreorders: (context, params) => {
        return new Promise((resolve, reject) => {
            ApiService.post('pos/checkin', params).then(result => {
                resolve(result)
            }).catch(err => {
                vm.$toasted.show(err)
                reject()
            }).finally(() => {
                resolve()
            })
        })
    },

    loadCompanies: (context) => {
        return new Promise((resolve, reject) => {
            let params = {}
            ApiService.get('pos/companies').then(result => {
                resolve(result)
            }).catch(err => {
                vm.$toasted.show(err)
                reject()
            }).finally(() => {
                resolve()
            })
        })
    }
}

const mutations = {

    /*
    * Set current order
    * then add it to local database
    */
    ['order']: (state, order) => {
        state.order = order
        vm.$db.setOrder(state.order)
    },

    /*
    * Add an item to current order
    * creates an unique id then updates local database with
    * current order's items
    */
    ['order_item_add']: (state, product) => {
        let item = {}
        item.id = uuid()
        item.qty = 1
        item.product = product
        state.order.items.push(item)
        vm.$db.updateOrderItems(state.order.items)
    },

    /*
    * Increase item quantity by one
    * then updates local database
    */
    ['order_item_increase_q']: (state, item) => {
        item.qty -= -1
        vm.$db.updateOrderItems(state.order.items)
    },

    /*
    * Decrease item quantity by one
    * then updates local database
    */
    ['order_item_decrease_q']: (state, item) => {
        item.qty -= 1
        vm.$db.updateOrderItems(state.order.items)
    },

    /*
    * Delete one item from current order
    * then updates local database
    */
    ['order_item_delete']: (state, item) => {
        let key = state.order.items.findIndex(product => { return product.id == item.id})
        Vue.delete(state.order.items, key)
        vm.$db.updateOrderItems(state.order.items)
    },

    /*
    * Add customer to current order
    * then updates local database
    */
    ['customer']: (state, customer) => {
        state.order.customer = customer
        vm.$db.setOrder(state.order)
    },

    /*
    * Add payment to current order
    * then updates local database
    */
    ['payment']: (state, payment) => {
        state.order.payments[payment.type] = payment.amount
        vm.$db.updatePayments(state.order.payments)
    },

    /*
    * Set orders
    */
    ['orders']: (state, orders) => {
        state.orders = orders
    },

    /*
    * Set preorders
    */
    ['preorders']: (state, preorders) => {
        state.preorders = preorders
    },

    /*
    * Set unsynced orders
    */
    ['unsynced']: (state, unsynced) => {
        state.unsynced = unsynced
    },

    /*
    * Update order's total before sync
    */
    ['total']: (state, total) => {
        state.order.total = total
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
